import PropTypes from 'prop-types';

import { CommonPaymentElementPropTypes } from '../../../propTypes';
import { Processors } from '../../../constants';

export const OxxoFormPropTypes = {
  ...CommonPaymentElementPropTypes,
  processor: PropTypes.oneOf(Processors).isRequired,
};
